<template>
    <b-form 
        @submit.prevent="cadastrar"
    >
        <div class="bg-gray p-3 p-md-4">
            <slot name="chamada">
                <h3 class="text-dark text-center text-uppercase mb-4">
                    Cadastro de parceiro
                </h3>
            </slot>
            <dados-gerais 
                :data="data" 
            />
            <endereco 
                :data="data" 
            />
            <acesso 
                :data="data" 
            />        
        </div>
        <div class="footer pt-2">
            <b-button 
                type="submit" 
                class="btn bg-olive btn-block text-uppercase"
            >
                Cadastrar
            </b-button>
            <div class="text-center">
                <a 
                    :href="`/${$url.module}/login`" 
                    class="small"
                >
                    <i class="fa fa-user"></i>
                    Já sou cadastrado
                </a>
            </div>
        </div>
    </b-form>
</template>
<script>
import '@/shared/plugins/recaptcha'
import '@/shared/common/directives/mascaras'
import DadosGerais from './DadosGerais'
import Endereco from './Endereco'
import Acesso from './Acesso'
import { onFocusField } from '@/shared/plugins/vee-validate/utils'
import { mapActions } from 'vuex'
export default {
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        DadosGerais,
        Endereco,
        Acesso,
    },
    data() {
        return {
            data: {
                Usuario: {},
                Empresa: { 
                    tipo: 'C', 
                    usuario_id: 1, 
                    dominio_id: 3 
                },
                Loja: { 
                    tipo_pessoa: 'PJ', 
                    estado: '', 
                    cidade_id: '' 
                },
            }
        }
    },
    mounted() {
        this.carrega()
    },
    methods: {
        ...mapActions('usuarios', {
            xLogin: 'login', 
        }),
        async carrega() {
            if(!this.$route.query.clienteContador){
                return false
            }
            const retorno = await this.$api.get(
                this.$route.fullPath
            )
            if (retorno.status == 'error') {
                this.$notify.error(retorno.message)
                this.$router.push(this.$urlBase + '/')
            }
        },
        async cadastrar () {
            const valido = await this.$validator.validateAll()
            if (!valido) {
                onFocusField(this)
                return
            }
            this.$loading.show()
            this.data['g-recaptcha-response'] = await this.$recaptcha('login')
            const retorno = await this.$api.cPost(
                this.$route.fullPath, 
                this.data
            )
            if (retorno.status == 'success') {
                const login = await this.login(
                    { 
                        Usuario: { 
                            email: this.data.Usuario.email, 
                            senha: this.data.Usuario.senha
                        }
                    }
                )
                if(login.status == 'success'){
                    // tempo necessário para salvar o token no navegador
                    setTimeout(() => {
                        location.href = this.$urlBase + '/inicio?primeiroacesso=true'
                    }, 1500)
                }
            }else {
                this.$dialog.error(retorno.message)
                this.$loading.hide()
            }
        },
        async login (dados) {
            const recaptcha = await this.$recaptcha('login')
            dados['g-recaptcha-response'] = recaptcha
            const login = await this.xLogin(dados)
            if (login.status == 'error'){
                this.$loading.hide()
                this.$dialog.error(login.message)
            }
            return login
        }
    }
}
</script>